import { QueryClient } from '@tanstack/react-query';

import { ApiClientError } from './api';

/**
 * Cliente de React Query compartido por la app.
 *
 * No se reintenta un 4xx: si la API dice que los datos no son válidos o que no
 * hay permiso, insistir no cambia nada. El resto (red, 5xx) se reintenta dos
 * veces con espera creciente.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry(failureCount, error) {
        if (error instanceof ApiClientError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: {
      retry: false,
    },
  },
});

/** Claves de caché, en un solo sitio para que no se dupliquen por ahí. */
export const queryKeys = {
  me: ['me'] as const,
  profile: ['me', 'profile'] as const,
  tokens: ['me', 'tokens'] as const,
  bodyMetrics: ['me', 'body-metrics'] as const,
  loginMethods: ['me', 'login-methods'] as const,
  authProviders: ['auth', 'providers'] as const,
};
